export default __webpack_public_path__ + "static/media/cat_nautischeboekhandel.36cf75a7.svg";